module.exports = "query ($id: ID!) {\n  Residential(id: $id) {\n    id\n    number\n    project {\n      id\n      name\n    }\n  }\n}\n"